import React from 'react';
import { PriceDisplay } from './PriceDisplay';
const CART_URL = 'https://instanthandbook.com/en/cart/add?id=44085498708019&quantity=1';
const items = [{
  name: 'The Home Healing Handbook (300+ remedies, 500+ pages)',
  value: 97,
  emoji: '📗'
}, {
  name: 'Bonus #1 — Your 15-Minute Natural First Aid Kit',
  value: 37,
  emoji: '🎁'
}, {
  name: 'Bonus #2 — The Remedy Cheat Sheet',
  value: 47,
  emoji: '🎁'
}, {
  name: 'Bonus #3 — The Consistency Code',
  value: 37,
  emoji: '🎁'
}, {
  name: 'Bonus #4 — The $40 Holistic Pantry',
  value: 47,
  emoji: '🎁'
}, {
  name: 'Bonus #5 — Beyond The Basics Masterclass',
  value: 97,
  emoji: '🎁'
}];
export function ValueStack() {
  const totalValue = items.reduce((sum, item) => sum + item.value, 0);
  return <section className="py-8 md:py-14 bg-white" data-id="element-324">
      <div className="max-w-3xl mx-auto px-4" data-id="element-325">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-center text-dark mb-4 md:mb-6" data-id="element-326">
          EVERYTHING YOU GET TODAY
        </h2>

        {/* Value Table */}
        <div className="bg-cream rounded-xl border border-primary/10 overflow-hidden mb-4 md:mb-6" data-id="element-327">
          <div className="divide-y divide-primary/10" data-id="element-328">
            {items.map((item, index) => <div key={index} className="flex items-center justify-between p-4" data-id="element-329">
                <div className="flex items-center gap-3" data-id="element-330">
                  <span className="text-xl" data-id="element-331">{item.emoji}</span>
                  <span className="text-dark" data-id="element-332">{item.name}</span>
                </div>
                <span className="font-bold text-dark whitespace-nowrap" data-id="element-333">
                  ${item.value}
                </span>
              </div>)}
          </div>

          {/* Total Row */}
          <div className="bg-primary/5 p-4 border-t-2 border-primary/20" data-id="element-334">
            <div className="flex items-center justify-between" data-id="element-335">
              <span className="font-bold text-dark" data-id="element-336">TOTAL VALUE</span>
              <span className="font-bold text-xl text-muted line-through" data-id="element-337">
                ${totalValue}
              </span>
            </div>
          </div>
        </div>

        {/* Your Price */}
        <div className="text-center mb-4 md:mb-6" data-id="element-338">
          <p className="text-muted uppercase tracking-wider text-sm mb-2" data-id="element-339">
            YOUR PRICE TODAY
          </p>
          <PriceDisplay amount={27} size="xl" data-id="element-340" />
        </div>

        {/* CTA */}
        <a href="https://instanthandbook.com/en/cart/add?id=44085498708019&quantity=1" className="block w-full bg-primary hover:bg-primary-light text-white font-bold text-xl px-10 py-5 rounded-lg transition-all duration-200 transform hover:scale-[1.02] shadow-xl hover:shadow-2xl text-center" data-id="element-341">
          ADD TO CART — GET INSTANT ACCESS »
        </a>

        <p className="text-center text-muted text-sm mt-4" data-id="element-342">
          Instant access · One-time payment · 14-day money back guarantee
        </p>
      </div>
    </section>;
}